import React, { useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { checkedState, unCheckedState, deleteAccountEmployeeExpenseEntryAsync, Edit, checkedAllState, unCheckedAllState, getExpenseEntryArchiveForDatatableAsync, updateSorting } from './ExpenseEntryArchiveSlice';
import CustomPagination from "../../../common/Pagination";
import moment from 'moment';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import clsx from 'clsx';
import { formatDateWithDateAndMonthName, setItemStatus, getValueFromResource, FormatInvoiceDecimalNumber } from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';
const ExpenseEntryArchiveItem = (props: any) => {
    const { expenseEntryArchiveList, onopenModal, t, IsEdit, IsDelete } = props;
    const { sortOrder, sortColumn, pageSize } = useAppSelector((state) => state.expenseEntryArchive);
    const { cultureInfoName, decimalPlaces } = useAppSelector((state) => state.globalState);

    const dispatch = useAppDispatch();
    const { isReload, optionEmployeeNameValue, optionApprovedValue, startDate, endDate, includeDateRange } = useAppSelector((state) => state.expenseEntryArchive);

    useEffect(() => {
        if (isReload) {
            let SearchParamsValues = `${optionEmployeeNameValue},${optionApprovedValue},${includeDateRange},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')}`;
            dispatch(getExpenseEntryArchiveForDatatableAsync(SearchParamsValues));
        }
    }, [isReload]);

    useEffect(() => {
        let SearchParamsValues = `${optionEmployeeNameValue},${optionApprovedValue},${includeDateRange},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')}`;
        dispatch(getExpenseEntryArchiveForDatatableAsync(SearchParamsValues));
    }, [dispatch]);


    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId));

        } else {
            dispatch(unCheckedState(rowId));

        }
    };



    const CheckStatusForTimeEntryArchive = (status: string) => {
        if (status === 'Submitted') {
            return <span className="badge badge-primary">
                {/* {t('Submitted')} */}
                {getValueFromResource('Submitted',dispatch, t)}
                </span>;
        } else if (status === 'Approved') {
            return <span className="badge badge-success">
                {/* {t('Approved')} */}
                {getValueFromResource('Approved',dispatch, t)}
                </span>;
        } else if (status === 'Rejected') {
            return <span className="badge badge-danger">
                {/* {t('Rejected')} */}
                {getValueFromResource('Rejected',dispatch, t)}
                </span>;
        }
        else {
            return <span className="badge badge-warning">
                {/* {t('Not Submitted')} */}
                {getValueFromResource('Not Submitted',dispatch, t)}
                </span>;
        }
    };

    const onEditClick = (expenseEntryArchiveObj: any) => {
        dispatch(Edit(expenseEntryArchiveObj));
        onopenModal();
    }

    const onDeleteClick = (expenseEntryArchiveObj: any) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountEmployeeExpenseEntryAsync(expenseEntryArchiveObj))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            ShowToast("Expense Entry(s) Deleted Succesfully", 'Success', "success", "toast-top-right")
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                        {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={expenseEntryArchiveList.every((item: any) => item.isSelected === 0) ? false : (expenseEntryArchiveList.every((item: any) => item.isSelected === 1 ? true : false))}
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        }
                        <th style={{ width: '20%' }}>
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name', dispatch, t)}
                            {sortColumn === 'EmployeeName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "EmployeeName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "EmployeeName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "EmployeeName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "EmployeeName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Date')} */}
                            {getValueFromResource('Date', dispatch, t)}
                            {sortColumn === 'ExpenseSheetDate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ExpenseSheetDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ExpenseSheetDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ExpenseSheetDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ExpenseSheetDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '25%' }}>
                            {/* {t('Description')} */}
                            {getValueFromResource('Description', dispatch, t)}
                            {sortColumn === 'Description' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Description") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Description") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Description") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Description") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Amount')} */}
                            {getValueFromResource('Amount', dispatch, t)}
                            {sortColumn === 'Amount' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Amount") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Amount") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Amount") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Amount") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Status')} */}
                            {getValueFromResource('Status', dispatch, t)}
                            {sortColumn === 'Status' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Status") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Status") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Status") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Status") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-50px text-center '>

                        </th>
                    </tr>
                </thead>
                <tbody>
                    {expenseEntryArchiveList.length === 0 && <tr><td colSpan={7}><p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found', dispatch, t)}
                    </p></td></tr>}
                    {expenseEntryArchiveList.length > 0 && expenseEntryArchiveList.map((expenseEntryArchiveObj: any, i: any) => (
                        <tr key={i}>
                            {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >

                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check"
                                            checked={expenseEntryArchiveObj.isSelected == 0 ? false : true}
                                            onChange={e => handleCheckboxChange(e, expenseEntryArchiveObj.AccountEmployeeExpenseSheetId)}
                                        />
                                    </div>
                                </td>
                            }
                            <td
                                className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                onClick={IsEdit ? () => onEditClick(expenseEntryArchiveObj) : undefined}
                            >
                                <span className="d-block">
                                    {expenseEntryArchiveObj.EmployeeName}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {/* {moment.parseZone(expenseEntryArchiveObj.ExpenseSheetDate).format('DD MMM yy')} */}
                                    {formatDateWithDateAndMonthName(expenseEntryArchiveObj.ExpenseSheetDate, cultureInfoName.toString())}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {expenseEntryArchiveObj.Description}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {FormatInvoiceDecimalNumber(cultureInfoName.toString(), expenseEntryArchiveObj.Amount, decimalPlaces)}
                                </span>
                            </td>

                            {/* <td>{CheckStatusForTimeEntryArchive(expenseEntryArchiveObj.Status)}</td> */}
                            <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(expenseEntryArchiveObj.Status))}>
                                    {expenseEntryArchiveObj.Status}
                                </span>
                            </td>
                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More', dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                        {IsEdit &&
                                            <>
                                                <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => { onEditClick(expenseEntryArchiveObj) }}
                                                    >
                                                        <span className="menu-icon custom-menu">
                                                            <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">
                                                            {/* {`${t('Edit')}`} */}
                                                            {getValueFromResource('Edit', dispatch, t)}
                                                        </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                        {IsDelete && IsEdit &&
                                            <div className='separator mb-1 mt-1 opacity-75 '></div>
                                        }
                                        {IsDelete &&
                                            <>
                                                <div className='menu-hover-bg-danger'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => { onDeleteClick(expenseEntryArchiveObj) }}
                                                    >
                                                        <span className="menu-icon  custom-menu">
                                                            <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                            {/* {`${t('Delete')}`} */}
                                                            {getValueFromResource('Delete', dispatch, t)}
                                                        </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </>
    )
}

export default ExpenseEntryArchiveItem